import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {ISupportSession, readSupportSession} from "../logic/supportSession";

export interface IAuthSliceState {
    loading: boolean;
    user?: any;
    userName?: string;
    token: string | undefined;
    accessToken: string | undefined;
    isAuthed: boolean;
    sessionKey: string | undefined;
    permissions: string[],
    searchSession: string | undefined;
    embeddedSession: boolean;
    /** Set while this tab is a support session (see logic/supportSession.ts). */
    supportSession?: ISupportSession;
}

// A reload of a support tab picks its session back up from sessionStorage.
const restoredSupportSession = readSupportSession();

const intialState: IAuthSliceState = {
    loading: true,
    user: null,
    userName: restoredSupportSession?.username,
    token: undefined,
    accessToken: undefined,
    isAuthed: !!restoredSupportSession,
    sessionKey: restoredSupportSession?.sessionKey,
    permissions: [],
    searchSession: undefined,
    embeddedSession: false,
    supportSession: restoredSupportSession,
}

const authSlice = createSlice({
    name: 'auth',
    initialState: intialState,
    reducers: {
        setSessionAuth: (state, action: PayloadAction<string>) => {
            state.sessionKey = action.payload;
            state.isAuthed = true;
        },
        setEmbeddedAuth: (state, action: PayloadAction<string>) => {
            state.sessionKey = action.payload;
            state.isAuthed = true;
            state.embeddedSession = true;
        },
        setAuth: (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.accessToken = action.payload?.accessToken;
            state.token = action.payload?.token;
            if (action.payload?.token) {
                try {
                    state.user = action.payload?.idToken?.claims;
                    state.userName = action.payload?.user;
                    state.isAuthed = true;
                } catch (error) {
                    console.error(error);
                    state.user = null;
                    state.userName = undefined;
                }
            } else {
                state.user = null;
                state.userName = undefined;

            }
        },
        setSearchSession: (state, action: PayloadAction<string>) => {
            state.searchSession = action.payload
        },
        setSupportAuth: (state, action: PayloadAction<ISupportSession>) => {
            state.sessionKey = action.payload.sessionKey;
            state.userName = action.payload.username;
            state.supportSession = action.payload;
            state.isAuthed = true;
            state.loading = false;
        },
        clearSupportAuth: (state) => {
            state.sessionKey = undefined;
            state.userName = undefined;
            state.supportSession = undefined;
            state.isAuthed = false;
        }
    }
});

export const { setAuth, setSessionAuth, setSearchSession, setEmbeddedAuth, setSupportAuth, clearSupportAuth } = authSlice.actions;

export default authSlice.reducer;